import { useState } from "react";
import { useMemo } from "react";
import AOSelect from "../../components/AOSelect";

const options = [
  {
    label: "Any Employment",
    value: "AnyEmployment",
  },
  {
    value: "Casual",
  },
  {
    value: "Contract",
  },
  {
    label: "Full Time Permanent",
    value: "Full Time - Permanent",
  },
  {
    label: "Full Time Fixed Term",
    value: "Full Time - Fixed Term",
  },
  {
    label: "Part Time Permanent",
    value: "Part Time - Permanent",
  },
  {
    label: "Part Time Fixed Term",
    value: "Part Time - Fixed Term",
  },
];

const WorkTypeFilter = ({ jobs, onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Counted fresh from jobs (not added onto the shared options) so reloading jobs can't double them
  const countedOptions = useMemo(
    () =>
      options.map((option) => ({
        ...option,
        count: jobs.filter(
          (j) => (j.jobType ?? "AnyEmployment") === option.value
        ).length,
      })),
    [jobs]
  );

  return (
    <AOSelect
      placeholder="All Work Types"
      value={
        selectedOptions.length > 2
          ? `${selectedOptions.length} Work Types`
          : null
      }
      options={countedOptions}
      onChange={(value) => {
        setSelectedOptions(value);
        if (onChange) onChange(value);
      }}
    />
  );
};

export default WorkTypeFilter;
